export default class PlanningDetailHelper {
  /**
   * Builds the request payload for the contracted override update API.
   * Handles both "even" (single total distributed) and "perItem" (individual values) modes.
   */
  static BuildOverrideRequestData(item) {
    return {
      Ids: JSON.stringify(item.PlanningDetailIds),
      DistributionType: item.DistributionType,
      NewTotal: item.DistributionType === 'even' ? item.NewTotal : null,
      Items:
        item.DistributionType === 'perItem'
          ? JSON.stringify(item.Items.map((i) => ({ PlanningDetailId: i.PlanningDetailId, Value: i.override })))
          : null,
    };
  }
}
